import { WIDGET_LABELS } from "@playbookai/widget-schemas";
import type { InteractionContext } from "@playbookai/player-ai-client";

export type WidgetReference = NonNullable<
  InteractionContext["selection_refs"]
>[number];
export interface WidgetAttachment {
  /** Draft identity, distinct from the referenced widget, for in-flight sends. */
  id: string;
  name: string;
  reference: WidgetReference;
}
export function widgetAttachmentName(kind: string): string {
  return Object.prototype.hasOwnProperty.call(WIDGET_LABELS, kind)
    ? WIDGET_LABELS[kind as keyof typeof WIDGET_LABELS]
    : "Widget";
}
export function sentWidgetAttachments(
  context: unknown,
): Array<{ id: string; name: string }> {
  if (!context || typeof context !== "object") return [];
  const refs = (context as Record<string, unknown>).selection_refs;
  if (!Array.isArray(refs)) return [];
  const seen = new Set<string>();
  return refs.flatMap((value: unknown) => {
    if (!value || typeof value !== "object") return [];
    const ref = value as Record<string, unknown>;
    if (
      ref.type !== "widget" ||
      typeof ref.widget_id !== "string" ||
      typeof ref.widget_kind !== "string"
    )
      return [];
    const scope = ref.scope_ref;
    if (
      !scope ||
      typeof scope !== "object" ||
      typeof (scope as Record<string, unknown>).surface_id !== "string"
    )
      return [];
    const id =
      String((scope as Record<string, unknown>).surface_id) +
      ":" +
      ref.widget_id;
    if (seen.has(id)) return [];
    seen.add(id);
    return [{ id, name: widgetAttachmentName(ref.widget_kind) }];
  });
}
